import React, { useState, useEffect } from 'react';
import './IssueBookStaff.css'; // Import your CSS file for styling
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';
function IssueBookForStaff() {
    const [searchBookStaff, setSearchBookStaff] = useState('');
    const [issueDateStaff, setIssueDateStaff] = useState('');
    const [returnDateStaff, setReturnDateStaff] = useState('');
    const [selectedEmployeeAuthorization, setSelectedEmployeeAuthorization] = useState('');
    const [employeeAuthorizationList, setEmployeeAuthorizationList] = useState([]);
    const [bookCopiesStaff, setBookCopiesStaff] = useState([]);
    const [loadingIssueBookStaff, setLoadingIssueBookStaff] = useState(false);
    const [errorIssueBookStaff, setErrorIssueBookStaff] = useState('');
    const [showIssueBookStaff, setShowIssueBookStaff] = useState(true); // Assuming you want to show this by default

    // Fetch employee authorization list when the component mounts
    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const response = await fetch(Constants.API_PATH + '/auth_employee_list'); // Replace with your API endpoint
                const data = await response.json();
                setEmployeeAuthorizationList(data);
            } catch (error) {
                console.error('Error fetching employees:', error);
            }
        };

        fetchEmployees();
    }, []);

    // Function to fetch book copies based on search input
    const fetchBookCopiesStaff = async () => {
        setLoadingIssueBookStaff(true);
        setErrorIssueBookStaff('');

        try {
            const response = await fetch(Constants.API_PATH + '/issued-books-student'); // Replace with your API endpoint
            if (!response.ok) {
                throw new Error(`Failed to fetch book copies: ${response.status}`);
            }
            const data = await response.json();
            setBookCopiesStaff(data);
        } catch (error) {
            console.error('Error fetching book copies:', error);
            setErrorIssueBookStaff('Failed to fetch book copies. Please check the console for details.');
        } finally {
            setLoadingIssueBookStaff(false);
        }
    };

    // Function to handle issuing a book
    const handleIssueBook = async (copy) => {
        if (!selectedEmployeeAuthorization) {
            alert('Please select a staff member to issue the book.');
            return;
        }

        try {
            const response = await fetch(Constants.API_PATH +'/issue-book', { // Replace with your API endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    employee_id: selectedEmployeeAuthorization,
                    book_copy_id: copy.id, // Assuming each copy has an id
                    issue_date: issueDateStaff,
                    due_date: returnDateStaff,
                }),
            });

            if (!response.ok) {
                throw new Error(`Failed to issue book: ${response.status}`);
            }

            alert('Book issued successfully!');
            // Optionally, reset the form or update the state here
        } catch (error) {
            console.error('Error issuing book:', error);
            alert('Failed to issue book. Please check the console for details.');
        }
    };

    // Function to handle resetting the form
    const handleResetStaff = () => {
        setSearchBookStaff('');
        setIssueDateStaff('');
        setReturnDateStaff('');
        setSelectedEmployeeAuthorization('');
        setBookCopiesStaff([]);
    };

    return (
        showIssueBookStaff && (
            <div className="issue-book-staff-section containernew">
                {/* <nav className="breadcrumb">
                    <a href="#" className="breadcrumb-link">Home</a> /
                    <a href="#" className="breadcrumb-link">Library Management</a> /
                    <span className="breadcrumb-current">Issue Book For Parent</span>
                </nav> */}
                <h2 className="section-title">Issue Book To Parent</h2>
                <div className="form-section">
                    <div className="form-group">
                        <label htmlFor="search-book-staff" className="form-label">Search by Book Name or Book Code</label>
                        <input
                            type="text"
                            id="search-book-staff"
                            className="form-input"
                            placeholder="Type to get book"
                            value={searchBookStaff}
                            onChange={(e) => setSearchBookStaff(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="date-of-issue" className="form-label">Date of Issue (yyyy-mm-dd)</label>
                        <input
                            type="text"
                            id="date-of-issue"
                            className="form-input"
                            value={issueDateStaff}
                            readOnly
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="date-of-return" className="form-label">Date of Return (yyyy-mm-dd)</label>
                        <input
                            type="text"
                            id="date-of-return"
                            className="form-input"
                            value={returnDateStaff}
                            onChange={(e) => setReturnDateStaff(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="employeeAuthorizationList" className="form-label">Staff</label>
                        <SearchableSelect
                            id="employeeAuthorizationList"
                            className="form-select"
                            value={selectedEmployeeAuthorization}
                            onChange={(e) => setSelectedEmployeeAuthorization(e.target.value)}
                            options={employeeAuthorizationList.map(employee => ({
                                value: employee.id,
                                label: employee.first_name
                            }))}
                            placeholder="--Select Staff--"
                            required
                            clearable={false}
                        />
                    </div>
                </div>
                <button className="submit-button" onClick={fetchBookCopiesStaff}>Search Books</button>
                <div className="table-responsive">
                    {loadingIssueBookStaff ? (
                        <p>Loading...</p>
                    ) : errorIssueBookStaff ? (
                        <p>{errorIssueBookStaff}</p>
                    ) : (
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>Sr No</th>
                                    <th>Staff name</th>
                                    <th>Book name</th>
                                    <th>Book Code</th>
                                    <th>Issue Date</th>
                                    <th>Due Date</th>
                                    <th>Copy Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookCopiesStaff.length === 0 ? (
                                    <tr>
                                        <td colSpan="6">No book copies found.</td>
                                    </tr>
                                ) : (
                                    bookCopiesStaff.map((copy, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{copy.staff_name}</td>
                                            <td>{copy.book_name}</td>
                                            <td>{copy.book_code}</td>
                                            <td>{copy.issue_date}</td>    
                                            <td>{copy.due_date}</td>
                                            <td>{copy.status}</td>                                                                                   <td>{copy.copyStatus}</td>
                                            <td>
                                                <button onClick={() => handleIssueBook(copy)}>Issue</button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
                <button className="reset-button" onClick={handleResetStaff}>Reset</button>
            </div>
        )
    );
}

export default IssueBookForStaff;